import {
  Accordion, AccordionItem, AccordionTrigger, AccordionContent,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "What should my child bring?",
    a: "Please pack a lunch, snacks, and a labeled water bottle each day. Dress your child in comfortable clothes and closed-toe shoes that are okay to get a little messy during crafts and play.",
  },
  {
    q: "What ages do you accept?",
    a: "WonderStarzLV welcomes children ages 3 to 12. Activities are thoughtfully grouped so every camper is challenged and supported at their level.",
  },
  {
    q: "Can I drop off or pick up early?",
    a: "Camp hours vary by location — check the weekly calendar above for each date's drop-off and pick-up times. If you need an earlier or later arrangement, reach out to us in advance and we'll do our best to accommodate.",
  },
  {
    q: "What happens if my child has allergies?",
    a: "Note any allergies or medical needs on the enrollment form. Our staff reviews every registration and takes care to keep your child safe throughout the day.",
  },
  {
    q: "Do you offer refunds?",
    a: "Refund availability depends on timing and the specific session. Please contact us as early as possible and we'll walk you through your options.",
  },
  {
    q: "How do I know which library location to choose?",
    a: "Check the 'Where We'll Be This Week' calendar above! Each highlighted date shows the library location, address, and time so you can pick the day and spot that works best for your family.",
  },
];

export const FAQSection = () => (
  <section id="faq" data-testid="faq-section" className="bg-yellow-50 py-16 sm:py-20">
    <div className="max-w-3xl mx-auto px-6">
      <h2 className="text-center font-display font-bold text-teal-600 text-4xl sm:text-5xl mb-10">
        Frequently Asked Questions
      </h2>
      <Accordion type="single" collapsible className="space-y-4">
        {FAQS.map((f, i) => (
          <AccordionItem
            key={i}
            value={`item-${i}`}
            data-testid={`faq-item-${i}`}
            className="bg-white rounded-2xl px-6 border-2 border-teal-100 border-b-2"
          >
            <AccordionTrigger className="font-display font-bold text-pink-500 text-base sm:text-lg hover:no-underline [&>svg]:text-pink-500">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-emerald-800 font-medium text-base leading-relaxed">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
